import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export default function PricingTooltip({ id, text, label }) {
    const [position, setPosition] = useState(null)
    const trigger = useRef(null)
    const bubble = useRef(null)
    function show() {
        const rect = trigger.current.getBoundingClientRect()
        setPosition({
            left: Math.max(
                8,
                Math.min(rect.left - 105, window.innerWidth - 238),
            ),
            top: rect.bottom + 8,
        })
    }
    useEffect(() => {
        if (!position) return
        const rect = bubble.current.getBoundingClientRect()
        if (rect.bottom > window.innerHeight - 8) {
            setPosition((previous) => ({
                ...previous,
                top: Math.max(
                    8,
                    trigger.current.getBoundingClientRect().top -
                        rect.height -
                        8,
                ),
            }))
        }
        const close = () => setPosition(null)
        const outside = (event) => {
            if (!trigger.current.contains(event.target)) close()
        }
        const escape = (event) => {
            if (event.key === 'Escape') close()
        }
        const onScroll = () => {
            if (document.activeElement === trigger.current) show()
            else close()
        }
        window.addEventListener('scroll', onScroll, true)
        window.addEventListener('resize', close)
        document.addEventListener('pointerdown', outside)
        document.addEventListener('keydown', escape)
        return () => {
            window.removeEventListener('scroll', onScroll, true)
            window.removeEventListener('resize', close)
            document.removeEventListener('pointerdown', outside)
            document.removeEventListener('keydown', escape)
        }
    }, [position])
    return (
        <>
            <button
                ref={trigger}
                type="button"
                aria-label={`About ${label}`}
                aria-describedby={position ? id : undefined}
                onMouseEnter={show}
                onMouseLeave={() => setPosition(null)}
                onFocus={show}
                onBlur={() => setPosition(null)}
                onClick={show}
                className="ml-[6px] inline-flex h-[15px] w-[15px] items-center justify-center cursor-help rounded-full bg-[#FFF1E8] text-[10px] font-extrabold text-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary">
                i
            </button>
            {position &&
                createPortal(
                    <div
                        ref={bubble}
                        id={id}
                        role="tooltip"
                        className="fixed z-[9999] w-[230px] max-w-[calc(100vw-16px)] rounded-lg bg-[#1A1D23] px-3 py-2 text-left text-xs font-medium leading-relaxed text-white shadow-lg"
                        style={position}>
                        {text}
                    </div>,
                    document.body,
                )}
        </>
    )
}
